<script setup>
import {Dialog, DialogOverlay, DialogPanel, TransitionChild, TransitionRoot} from "@headlessui/vue";
import {Icon} from "@iconify/vue";
import {computed, onMounted, ref, nextTick} from "vue";

const emit = defineEmits(['closeModal', 'selectServer']);
const props = defineProps({
  servers: Array
})
const searchInput = ref(null)
const isLoading = ref(false);
const search = ref('')

function closeModal() {
  emit('closeModal');
}


function selectServer(s) {
  emit('selectServer', s)
}


const filteredServers = computed(() => {
  return props.servers.filter(server =>
      server.toLowerCase().includes(search.value.toLowerCase().trim())
  )
})

onMounted(()=>{
  nextTick(() => {
    searchInput.value?.focus()
  })
})
</script>

<template>
  <TransitionRoot appear show as="template">
    <Dialog as="div" @close="closeModal" class="relative z-[999]">
      <TransitionChild
          as="template"
          enter="duration-300 ease-out"
          enter-from="opacity-0"
          enter-to="opacity-100"
          leave="duration-200 ease-in"
          leave-from="opacity-100"
          leave-to="opacity-0"
      >
        <DialogOverlay class="fixed inset-0 bg-[black]/60"/>
      </TransitionChild>

      <div class="fixed inset-0 overflow-y-auto">
        <div class="flex h-full overflow-hidden items-center justify-center px-4 py-8">
          <TransitionChild
              as="template"
              enter="duration-300 ease-out"
              enter-from="opacity-0 scale-95"
              enter-to="opacity-100 scale-100"
              leave="duration-200 ease-in"
              leave-from="opacity-100 scale-100"
              leave-to="opacity-0 scale-95"
          >
            <DialogPanel
                class="w-full flex flex-col overflow-hidden rounded-md max-w-max h-full max-h-max text-left align-middle shadow-xl transition-all bg-white dark:bg-[#0e1726] text-black-600 dark:text-white">
              <div class="h-full max-h-max flex flex-col">
                <div class="flex flex-row justify-between px-3 border-b border-slate-700">
                  <div class="text-sm py-3">
                    Select Server
                  </div>
                  <div class="flex flex-row items-center gap-3">
                    <div class="h-full w-[1px] bg-slate-700"></div>
                    <button
                        type="button"
                        class="text-white-dark outline-none hover:text-red-500"
                        @click="closeModal"
                    >
                      <Icon icon="pajamas:close-xs"/>
                    </button>
                  </div>
                </div>
                <div class="p-3 flex-1 overflow-hidden max-h-full flex flex-col">
                  <p v-if="isLoading">Loading...</p>
                  <div v-else class="flex flex-col gap-2 h-full">
                    <div class="w-full dark:bg-slate-900 border border-slate-700 pr-3 rounded-md h-[34px]">
                      <input id="search" ref="searchInput" type="text"
                             v-model="search"
                             placeholder="search ..."
                             class="bg-transparent w-full pl-3 block text-sm focus:outline-none text-slate-900 dark:text-slate-200 h-full rounded-md autofill-fix dark:[&#45;&#45;shadow-color:#0f172a] [&#45;&#45;text-color:#0f172a] dark:[&#45;&#45;text-color:rgb(203,213,225)] dark:[&#45;&#45;caret-color:rgb(203,213,225)]">
                    </div>
                    <div class="flex-1 overflow-auto custom-scrollbar-2">
                      <ul v-if="filteredServers.length > 0" class="h-max">
                        <li v-for="s in filteredServers" @click="selectServer(s)"
                            class="text-sm cursor-pointer hover:bg-slate-800 rounded-md p-2 flex flex-row gap-2">
                          <span class="text-[4px]">⬤</span>{{ s }}
                        </li>
                      </ul>
                      <p v-else class="p-2 text-sm flex items-center">Nothing matched</p>
                    </div>
                  </div>
                </div>
<!--                <div class="px-3 pb-3 flex justify-end gap-3">
                  <button type="submit" class="btn btn-outline-primary py-2">
                    <span
                        class="animate-[spin_2s_linear_infinite] inline-block align-middle ltr:mr-2 rtl:ml-2 shrink-0"></span>
                    Save
                  </button>
                </div>-->
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<style scoped lang="scss">

</style>